import React from "react";

import { trim } from "lodash/fp";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { Row } from "@rui/Stack";

const Chip = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[4],
  color: theme.palette.shades.neutral[400],
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  padding: `${theme.spaces.xxsmall} ${theme.spaces.small}`,
  borderRadius: theme.corners.small,
  flexShrink: 1,
  overflow: "hidden",
  flexWrap: "nowrap",
  maxWidth: "54px", // width of the "Edited" text

  "&:hover": {
    cursor: "default",
    maxWidth: "100%",
    backgroundColor: theme.palette.transparent.black[8],
    color: theme.palette.shades.neutral[600],
  },
}));

const EditedChip = ({ editedBy }: { editedBy?: string }) => {
  const editedByValue = trim(editedBy ?? "");
  return (
    <Chip>
      <Typography variant="labelMed">Edited</Typography>
      {editedByValue && (
        <Typography variant="labelMed" noWrap>
          &nbsp;by {editedByValue}
        </Typography>
      )}
    </Chip>
  );
};

export default EditedChip;
